import { initCalcUI } from './ui.js';
import { initScenarios } from './scenarios.js';

document.addEventListener('DOMContentLoaded', async () => {
    const configEl = document.getElementById('calc-config-json');
    const stateEl = document.getElementById('calc-state-json');
    const config = configEl ? JSON.parse(configEl.textContent) : {};
    const state = stateEl ? JSON.parse(stateEl.textContent) : {};

    initCalcUI(config, state);
    if (state.isAuthenticated) {
        await initScenarios(state);
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('pendingSave') === '1' && state.isAuthenticated) {
        document.dispatchEvent(new CustomEvent('loanCalc:save-request'));
        urlParams.delete('pendingSave');
        const cleanSearch = urlParams.toString();
        const cleanUrl = cleanSearch
            ? `${window.location.pathname}?${cleanSearch}`
            : window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
    }
});
